import React from 'react';
import { NavLink } from 'react-router-dom';

import styles from './NavItem.css'

const navItem = (props) => (
    <li className={styles.NavItem}>
        <NavLink
            to={props.link}
            exact={props.exact}
            activeClassName={styles.active} >{props.children}</NavLink>
    </li>
);

export default navItem;


// WEBPACK FOOTER //
// ./src/components/Navigation/NavItems/NavItem/NavItem.js